import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import PopupPortal from './PopupPortal'

type PopupArgs = {
  title: string | React.ReactNode
  message: string | React.ReactNode
  status: 'error' | 'warning' | 'success'
  icon?: React.ReactNode
  width?: number
  okText?: string
  cancelText?: string
  onOk?: () => void
  onCancel?: () => void
}

export function Popup({
  title,
  message,
  onOk,
  onCancel,
  okText,
  cancelText,
  status,
  width,
}: PopupArgs) {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div)

  const PopupWrapper = () => {
    const [isOpen, setIsOpen] = useState(true)

    const handleOk = () => {
      setIsOpen(false)
      onOk?.()
    }

    const handleCancel = () => {
      setIsOpen(false)
      onCancel?.()
    }

    useEffect(() => {
      if (!isOpen) {
        setTimeout(() => {
          root.unmount()
          div.remove()
        }, 300)
      }
    }, [isOpen])

    return (
      <PopupPortal
        title={title}
        message={message}
        isOpen={isOpen}
        onOk={handleOk}
        onCancel={onCancel ? handleCancel : undefined}
        okText={okText}
        cancelText={cancelText}
        status={status}
        width={width}
      />
    )
  }

  root.render(<PopupWrapper />)
}
